export default __webpack_public_path__ + "static/media/76.d1880efe.jpg";